import { Switch } from '@mui/material';
import styled from '@emotion/styled';

const StyledSwitch = styled(Switch)(({ theme, primary, isDarkMode, businessPreference }) => ({
    width: 28,
    height: 12,
    marginBottom: 2,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: 0,
        left: 0,
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: primary ? theme.palette.primary.main : '#4A4A4A',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
    },
    '& .MuiSwitch-track': {
        height: 12,
        borderRadius: 6,
        opacity: 1,
        backgroundColor: isDarkMode ? '#4A4A4A' : '#E0E0E0',
        transition: theme.transitions.create(['background-color', 'border']),
    },
}));

const GeneralSwitch = ({
    checked,
    primary,
    isDarkMode,
    businessPreference,
    className = 'middle-content',
    disabled = false,
    ...props
}) => {
    return (
        <StyledSwitch
            checked={checked}
            color="primary"
            inputProps={{ 'aria-label': 'primary checkbox' }}
            disabled={disabled}
            className={className}
            primary={primary}
            isDarkMode={isDarkMode}
            businessPreference={businessPreference}
            {...props}
        />
    );
};

export default GeneralSwitch; 